// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__1Pbc-","box":"WorkspacesBox_box__1x6ZS","node":"WorkspacesBox_node__2e069"};